import { useLocation } from 'react-router-dom';
import { StyledLink } from './styles';

const NavLink = ({ children, to, onClick }) => {
  const location = useLocation();

  return (
    <StyledLink onClick={onClick}
      to={to}
      isActive={location.pathname.includes(to)}>
      {children}
    </StyledLink>
  );
};

export default NavLink;
